import { NgModule } from '@angular/core';
import {
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  TRANSLOCO_TRANSPILER,
  TranslocoModule,
  TranslocoConfig,
  DefaultTranspiler,
} from '@ngneat/transloco';
import { environment } from '../environments/environment';
import { TranslocoHttpLoader } from './transloco.loader';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: {
        availableLangs: ['en', 'pt'], 
        defaultLang: 'en', 
        reRenderOnLangChange: true,
        prodMode: environment.production,
      } as TranslocoConfig,
    },
    {
      provide: TRANSLOCO_LOADER,
      useClass: TranslocoHttpLoader,
    },
    {
      provide: TRANSLOCO_TRANSPILER,
      useClass: DefaultTranspiler,
    },
  ],
})
export class TranslocoRootModule {}
